import React, { Component } from 'react';
import { BsyUtils } from "../../utils/Utils";
import BsySelectCheckBox from '../BsySelectCheckBox';
import './index.css'
import BsyButton from "../BsyButton";
import BsySelect from "../BsySelect";
import BsySLoading from '../BsySLoading';
import BsyRadioBox from "../BsyRadioBox";
import BsyRadioGroup from "../BsyRadioGroup";
import BsyComboCheckBox from "../BsyComboCheckBox";
import BsyComboBox from "../BsyComboBox";
import noDataImg from "../../images/img_yinyongguanxi@2x.png";
import SimpleGraph from "./SimpleGraph.jsx";
export default class BsyRelationshipForm extends Component {

  static defaultProps = {
    appId: "",
    entryId: ""
  }

  constructor(props) {
    super(props);
    this.state = {
      type: "1",
      filterListConfig: [],
      modeValue: null,
      typeValue: null,
      formListValue: null,
      byFormListValue: null,
      byReferenceValue: "1",
      skip: 0,
      limit: 50,
      has_next: false,
      formList: [],
      viewData: [],
      staticJsonData: {},
      exist: false,
      isLoading: false,
      isTableLoading: false,
      isOpening: false,
    }
    this.simpleGraphRef = React.createRef();
  }

  listIndex = {
    formInfo: {
      name: React.language('formInfo.label'),
      key: 0
    },
    modeInfo: {
      name: React.language('modeInfo.label'),
      key: 1
    },
    typeInfo: {
      name: React.language('typeInfo.label'),
      key: 2
    },
    byFormInfo: {
      name: React.language('byFormInfo.label'),
      key: 3
    },
    detailsInfo: {
      name: React.language('detailsInfo.label'),
      key: 4
    },
  }

  listHeader = [
    {
      name: React.language('formInfo.label'),
      type: "formInfo",
      key: 0
    },
    {
      name: React.language('modeInfo.label'),
      type: "modeInfo",
      key: 1
    },
    {
      name: React.language('typeInfo.label'),
      type: "typeInfo",
      key: 2
    },
    {
      name: React.language('byFormInfo.label'),
      type: "byFormInfo",
      key: 3
    },
    {
      name: React.language('detailsInfo.label'),
      type: "detailsInfo",
      key: 4
    },
  ]

  componentDidMount() {
    this.reloadAllList()
  }

  reloadAllList = () =>{
    const { appId, entryId } = this.props;
    const { skip, limit, byReferenceValue } = this.state;
    this.setState({isLoading: true, isTableLoading: false},()=>{
      React.axios("/data/reference_prepose",{
        appId: appId, formId: entryId
      }).then(res=>{
        if(!res.data.exist){
          this.setState({exist: res.data.exist, isLoading: false})
          return
        }
        const { referenceMode, referenceType, referenceFormList, referenceByFormList } = res.data.data;
        const filterListConfig = [
          {
            items: referenceType.map(res => {
              return {
                value: res.id,
                text: res.name,
              }
            }),
            name: React.language('referenceType.label'),
            type: "referenceType"
          },
          {
            items: referenceMode.map(res=>{
              return {
                value: res.id,
                text: res.name,
              }
            }),
            name: React.language('referenceMode.label'),
            type: "referenceMode"
          },
          {
            items: referenceFormList.map(res => {
              return {
                value: res.id,
                text: res.name,
                formType: res.formType
              }
            }),
            name: React.language('referenceFormList.label'),
            type: "referenceFormList"
          },
          {
            items: referenceByFormList.map(res => {
              return {
                value: res.id,
                text: res.name,
                formType: res.formType
              }
            }),
            name: React.language('referenceByFormList.label'),
            type: "referenceByFormList"
          },
          {
            items: [
              {
                value: "1",
                text: React.language('byReference.item1'),
              },
              {
                value: "2",
                text: React.language('byReference.item2'),
              },
            ],
            name: React.language('byReference.label'),
            type: "byReference"
          }
        ];
        React.axios("/data/reference_list",{
          appId: appId, formId: entryId, skip, limit, byReference: byReferenceValue
        }).then(res1 =>{
          const nl = res1.data.list.map(res =>{
            const f = []
            BsyUtils.forEach(res, (v, k) =>{
              f[this.listIndex[v].key] = {
                cont: k,
                type: v
              }
            })
            return f
          })
          this.setState({exist: res.data.exist, filterListConfig, has_next: res1.data.has_next, formList: nl, viewData: res1.data.list, isLoading: false});

        })
      })
    })
  }

  reloadDataList = () =>{
    const { appId, entryId } = this.props;
    const { skip, limit, modeValue, typeValue, formListValue, byFormListValue, byReferenceValue } = this.state;
    this.setState({isTableLoading: true}, ()=>{
      React.axios("/data/reference_list",{
        appId: appId,
        formId: entryId,
        referenceMode: modeValue,
        referenceType: typeValue,
        referenceFormid: formListValue,
        referenceByFormid: byFormListValue,
        byReference: byReferenceValue,
        skip: skip,
        limit,
      }).then(res =>{
        const nl = res.data.list.map(res =>{
          const f = []
          BsyUtils.forEach(res, (v, k) =>{
            f[this.listIndex[v].key] = {
              cont: k,
              type: v
            }
          })
          return f
        })
        this.setState({isTableLoading: false, formList: nl, viewData: res.data.list, has_next: res.data.has_next})
      })
    })

  }

  getFilterValue =  (type) => {
    switch (type){
      case "referenceMode":
        return this.state.modeValue
      case "referenceType":
        return this.state.typeValue
      case "referenceFormList":
        return this.state.formListValue
      case "referenceByFormList":
        return this.state.byFormListValue
      case "byReference":
        return this.state.byReferenceValue
    }
  }

  setFilterValue =  (type, value) => {
    if(value === ""){
      value = null;
    }
    switch (type){
      case "referenceMode":
        this.setState({modeValue: value})
        break;
      case "referenceType":
        this.setState({typeValue: value})
        break;
      case "formInfo":
        this.setState({formListValue: value, skip: 0},()=>{
          this.reloadDataList()
        })
        break;
      case "referenceFormList":
        this.setState({formListValue: value})
        break;
      case "byFormInfo":
        this.setState({byFormListValue: value, skip: 0},()=>{
          this.reloadDataList()
        })
        break;
      case "referenceByFormList":
        this.setState({byFormListValue: value})
        break;
      case "byReference":
        this.setState({byReferenceValue: value, skip: 0},()=>{
          this.reloadDataList()
        })
        break;
    }
  }

  createFilterItem = (res) =>{
    const { byReferenceValue } = this.state;
    const { formType } = this.props;
    const rv = formType === "dash" ? "1" : byReferenceValue;
    const rt = formType === "dash" ? [
      {
        value: "1",
        text: React.language(`byReference.${formType}.item1`),
      }
    ]:[
      {
        value: "1",
        text: React.language(`byReference.${formType}.item1`),
      }, {
        value: "2",
        text: React.language(`byReference.${formType}.item2`),
      }
    ]
    return !((byReferenceValue === "2" && res.type === "referenceByFormList") || (byReferenceValue === "1" && res.type === "referenceFormList")) && <div className={`filter-item ${res.type} ${((byReferenceValue === "2" && res.type === "referenceByFormList") || (byReferenceValue === "1" && res.type === "referenceFormList")) ? "noEdit" : ""}`}>
      <div className="item-label" title={res.name}>{res.name}</div>
      <div className="item-cont">
        {
          (res.type === "referenceMode" || res.type === "referenceType") ?
            <BsyComboCheckBox
              allowBlank={!0}
              searchable={true}
              width={200}
              height={34}
              items={res.items}
              value={this.getFilterValue(res.type)}
              onStopEdit={(val) => {
                this.setFilterValue(res.type, val)
              }}
            /> :
            res.type === "byReference" ?
              <BsyRadioGroup
                layout={'horizontal'}
                required={!0}
                value={rv}
                items={rt}
                onStopEdit={(e) => {
                  this.setFilterValue(res.type, e)
                }}
              />
              :
              <BsyComboBox
                allowBlank={!0}
                searchable={true}
                width={(res.type === "referenceByFormList" || res.type === "referenceFormList") ? 350 : 200}
                height={34}
                items={res.items}
                isFormType={!0}
                value={this.getFilterValue(res.type)}
                onStopEdit={(val) => {
                  this.setFilterValue(res.type, val)
                }}
              />
        }
      </div>
    </div>
  }

  createListTd = (v) =>{
    const { byReferenceValue } = this.state;
    switch (v.type){
      case "typeInfo":
        return <span>{v.cont.name}</span>
      case "modeInfo":
        return <span>{v.cont.name}</span>
      case "formInfo":
      case "byFormInfo":
        const f = v.cont.formType !== "extend" ? ((v.cont.formId && v.cont.appId) ? (v.cont.formId + "@" + v.cont.appId) : "") : v.cont.id;
        const h = (v.cont.formType !== "extend" && v.cont.appId && v.cont.formId) || (v.cont.formType === "extend" && v.cont.id);
        const n =  v.cont.formType === "extend" ? v.cont.name : v.cont.formName;
        const isDel = !n;
        const hasPop = (byReferenceValue === "1" && v.type === "byFormInfo") || (byReferenceValue === "2" && v.type === "formInfo");
        return <>
          <span className={`${isDel ? "isDel" : ""} ${(hasPop && h && !isDel) ? "hasHover" : "" }`} onClick={()=>{
            hasPop && h && !isDel && this.setFilterValue(v.type, f)
          }}>
            {n}
            {
              isDel && <i>({React.language("deleted")})</i>
            }
          </span>
        </>
      case "detailsInfo":
        return <span title={v.cont.tipTextAll}>
          {v.cont.tipText}
          {!!v.cont.url && <a href={v.cont.url} target="_blank" className={`link-tip`}> {React.language('detail')}</a>}
        </span>
    }
  }

  openReference= () =>{
    this.setState({isOpening: true},()=>{
      React.axios("/data/teamReference_refresh").then(res=>{
        if(res.data.code === 200){
          this.setState({isOpening: false, exist: true},()=>{
            this.reloadAllList()
          })
        }else{
          this.openReference()
        }
      })
    })

  }

  render() {
    const { type, filterListConfig, isLoading, isTableLoading, has_next, formList, skip, limit, exist, isOpening, byReferenceValue, viewData } = this.state;

    return <div className="BsyRelationshipForm">
      {
        isLoading && <BsySLoading style={{ background: '#ffffff' }} text={" "}/>
      }
      {
        isOpening && <BsySLoading style={{ background: '#ffffff' }} text={React.language("reference.opening.text")} />
      }
      {
        !exist && <div className={"no-data"}>
          <div className="empty-content">
            <img src={noDataImg} alt="" />
            <p>{React.language('reference.empty.text')}</p>
            <div className="openReferenceBtn" onClick={this.openReference}>{React.language('reference.open.text')}</div>
          </div>
        </div>
      }
      {
        exist && <>
          <div className="relationship-header">
            <div className={`header-item ${type === "1" ? "select" : ""}`} onClick={()=>{this.setState({type: "1"})}}>
              <i className="icon-bsy-search-small"></i>
              <span>{React.language("reference.relationship.query")}</span>
            </div>
            <div className={`header-item ${type === "2" ? "select" : ""}`} onClick={()=>{this.setState({type: "2"})}}
            onMouseEnter={(event) => {
             window.FX.UI.showPopover({
               position: "bottomLeft",
               anchor: window.$(event.target),
               content: window.$("<span style='display: block;width: 300px;'/>").text(React.language('reference.relationship.view.tip')),
               type: "dark"
             })
            }} onMouseLeave={() => {
              window.FX.UI.closePopover()
            }}>
              <i className="icon-bsy-reference-view"></i>
              <span>{React.language("reference.relationship.view")}</span>
            </div>
          </div>
          <div className={`relationship-body ${type === "1" ? "list" : "view"}`} style={{padding: type !== "1" ? "0" : ""}}>
            {
              type === "1" && <div className="filter-cont">
                <div className="filter-line">
                  <div className="line-left">
                    {
                      filterListConfig.map(res => {
                        return res.type === "byReference" && this.createFilterItem(res)
                      })
                    }
                  </div>
                </div>
                <div className="filter-line">
                  <div className="line-left">
                    {
                      filterListConfig.map(res => {
                        return (res.type === "referenceType" || res.type === "referenceMode" || res.type === "referenceFormList" || res.type === "referenceByFormList") && this.createFilterItem(res)
                      })
                    }
                  </div>
                  <div className="line-right">
                    <BsyButton
                      text={React.language('query')}
                      type={"blue"}
                      click={() => {
                        this.reloadDataList()
                      }}
                      mode={window.mode}
                    />
                  </div>
                </div>
              </div>
            }
            {type === "1" ?
              <div className={"relationship-list"}>
                <div className="list-cont">
                  <div className="cont-table">
                    <div className="table-header">
                      <div className="table-tr">
                        {
                          this.listHeader.map(res =>{
                            return <div className={`table-td ${res.type}`}>
                              <div className={`td-cont`}>
                                <span>{res.name}</span>
                              </div>
                            </div>
                          })
                        }
                      </div>
                    </div>
                    <div className="table-body">
                      {
                        isTableLoading && <BsySLoading style={{ background: '#ffffff' }} />
                      }
                      {
                        formList.length > 0 && formList.map(res =>{
                          return <div className="table-tr">
                            {
                              res.map(v => {
                                return <div className={`table-td ${v.type}`}>
                                  <div className={`td-cont`}>
                                    {this.createListTd(v)}
                                  </div>
                                </div>
                              })
                            }
                          </div>
                        })
                      }

                    </div>
                  </div>
                  <div className="table-turn-page">
                    <div className="page-cont">
                      <div className={`page-pre-first page-item ${skip !== 0 ? "" : "disabled"}`} onClick={()=>{
                        this.setState({skip: 0}, ()=>{
                          this.reloadDataList()
                        })
                      }}>
                        <i className="icon-anglefirst"></i>
                      </div>
                      <div className={`page-pre page-item ${skip !== 0 ? "" : "disabled"}`} onClick={()=>{
                        this.setState({skip: skip - limit}, ()=>{
                          this.reloadDataList()
                        })
                      }}>
                        <i className="icon-bsy-left"></i>
                      </div>
                      <div className={`page-next page-item ${has_next ? "" : "disabled"}`} onClick={()=>{
                        this.setState({skip: skip + limit}, ()=>{
                          this.reloadDataList()
                        })
                      }}>
                        <i className="icon-bsy-right"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              :
              <div className={"relationship-view"} key={1}>
                {
                  isTableLoading && <BsySLoading style={{ background: '#ffffff' }} />
                }
                {
                  !isTableLoading &&
                    <SimpleGraph
                      key={1}
                      ref={this.simpleGraphRef}
                      viewData={viewData}
                      byReferenceValue={byReferenceValue}
                    />
                }
              </div>
            }
          </div>
        </>
      }
    </div>
  }
}